import axios from 'axios';

// const api = axios.create({
//   baseURL: 'http://localhost:5001/api',
//   headers: { 'Content-Type': 'application/json' },
// });

const api = axios.create({
  baseURL: 'https://workshop-backend-hv5d.onrender.com/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
